/**
 * ConfirmModal.js
 * Talkroute
 *
 * Created by Vel Genov on 2/28/20
 * Copyright (c) 2020 Talkroute. All right reserved.
 */

import React from "react";
import os from "os";
import { Button } from "semantic-ui-react";

interface IConfirmModal {
  title: string;
  desc: string;
  buttonLabel: string;
  clickActionCallback: () => any;
}

/**
 * A React component responsible for displaying the confirm modal dialog to cover the whole app
 *
 * This dialog contains only a title, a description, a button
 */
class ConfirmModal extends React.Component<IConfirmModal, any> {
  static defaultProps = {
    title: "",
    desc: "",
    buttonLabel: "",
  };

  /**
   * Called when user clicks the button
   */
  onButtonClick = () => {
    const { clickActionCallback } = this.props;

    clickActionCallback();
  };

  render() {
    const { title, desc, buttonLabel } = this.props;
    const top = os.platform() === "win32" ? "28px" : "0";

    return (
      <div
        style={{
          zIndex: 8,
          position: "fixed",
          height: "100%",
          width: "100%",
          top: "0",
          left: "0",
          padding: "0",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "var(--color-light-grey)",
            opacity: "0.8",
            position: "absolute",
            top,
          }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            position: "absolute",
            top,
          }}
        >
          <div
            style={{
              backgroundColor: "var(--color-white)",
              width: "400px",
              border: "1px solid var(--color-dark-grey)",
              borderRadius: "20px",
              boxShadow: "0 4px 24px 0 rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              className="text-large"
              style={{
                borderBottom: "1px solid var(--color-dark-grey)",
                textAlign: "center",
                fontWeight: 700,
                padding: "20px 0 15px 0",
              }}
            >
              {title}
            </div>
            <div
              className="text-large"
              style={{
                padding: "15px 15px 0 15px",
                textAlign: "center",
                lineHeight: "21px",
              }}
            >
              {desc}
            </div>
            <div
              className="text-normal"
              style={{
                padding: "15px 15px 15px 15px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                basic
                icon
                onClick={this.onButtonClick}
                style={{ margin: "0" }}
              >
                {buttonLabel}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmModal;
